import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IHealthDashboardData } from 'src/apis/dashboard/dashboardHealth.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardHealthKey = 'get-dashboard-health';

export const useDashboardHealthHook = (
  options?: UseQueryOptions<IHealthDashboardData, TQueryError>
): UseQueryResult<IHealthDashboardData, TQueryError> => {
  const { getHealthDashboardData } = useDashboardService();

  return useQuery<IHealthDashboardData, TQueryError>({
    queryKey: [getDashboardHealthKey],
    queryFn: () => getHealthDashboardData(),
    enabled: true,
    ...options,
  });
};
